import {Card} from "@material-ui/core";
import React from "react";
import styled from "@material-ui/core/styles/styled";

export const AaCard = styled(Card)(() => ({
  backgroundColor: "#f9f9f9"
}));
